import type React from "react";

import classNames from "classnames";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

import { StyledAddToListDropdownItem } from "./styles";
import type { AddToListDropdownItemProps } from "./types";

const AddToListDropdownItem = ({
    list,
    onClick,
    iconName = "list-icon",
    disabled = false,
}: AddToListDropdownItemProps) => {
    const handleClick = ({ currentTarget }: React.SyntheticEvent<HTMLDivElement>) => {
        // Workaround because active css selector not work in this case #SIM-34922
        if (!currentTarget.classList.contains("disabled")) {
            currentTarget.classList.add("visited");
        }
        onClick(list);
    };

    return (
        <StyledAddToListDropdownItem
            className={classNames({ disabled: disabled })}
            onClick={handleClick}
            data-automation={`add-to-list-dropdown-item-${list.opportunityListId}`}
        >
            <SWReactIcons
                iconName={iconName}
                size="xs"
            />
            <TruncatedTextWithTooltip
                data-automation="add-to-list-dropdown.item.text"
                fontVariant="input2"
                color={colorsPalettes.black[0]}
            >
                {list.friendlyName}
            </TruncatedTextWithTooltip>
        </StyledAddToListDropdownItem>
    );
};

export default AddToListDropdownItem;
